import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { PDFProvider } from './context/PDFContext';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EditorPage from './pages/EditorPage';
import PricingPage from './pages/PricingPage';
import PaymentSuccess from './pages/PaymentSuccess';
import ToolLanding from './pages/ToolLanding';
import AuthCallback from './pages/AuthCallback';
import AccountPage from './pages/AccountPage';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import '@/App.css';

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id — must happen synchronously before routes render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  const hideFooter = location.pathname.startsWith('/editor');
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/tools/:toolSlug" element={<ToolLanding />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <PDFProvider>
          <BrowserRouter>
            <div className="App min-h-screen bg-background">
              <Header />
              <AppRouter />
              <Toaster position="top-center" richColors />
            </div>
          </BrowserRouter>
        </PDFProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
